import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    DateField,
    SearchInput,

} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import classnames from 'classnames';
import ErrorBoundary from '../ErrorBoundary';

const coloredStyles = {
    red:    { color: 'red' },
    yellow: { color: 'yellow' },
    blue:   { color: 'blue' },
};

const bgColoredStyles = {
    red:    { backgroundColor: 'red' },
    yellow: { backgroundColor: 'yellow' },
};

const colored = WrappedComponent => withStyles(bgColoredStyles)(
    ({ classes, ...props }) => (
        <WrappedComponent
            className={classnames({
                [classes.red]: props.record[props.source] === 'PR',
                [classes.yellow]: props.record[props.source] === 'TD' ,
            })}
            {...props}
        />
    ));


const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const listStyles = {
    actions: {
        backgroundColor: 'Lavender',
    },
    header: {
        backgroundColor: '#def',
        fontWeight: 'bold',
    },
    inlineBlock: {
        display: 'inline-flex', 
        marginRight: '1rem' 
    },
};

const styles = {
    inlineBlock: {
        display: 'inline-flex', 
        marginRight: '1rem' 
    },
    hidden: {
        display: 'none'
    },
    container: {
        display: 'flex',
    },
};

const QuickFilter = translate(
    withStyles(quickFilterStyles)(({ classes, label, translate }) => (
        <Chip className={classes.root} label={translate(label)} />
    ))
);



export const DonorFilter = props => (
    <Filter {...props}>
        <SearchInput source="day"  placeholder="Expire in day(s)" alwaysOn  />
      
    </Filter>
);



export const ExpireList = ({ classes, permissions, ...props }) => (
    <ErrorBoundary>  
    <List 
        classes={classes}
        {...props}
        perPage={20}
        sort={{ field: 'last_name', order: 'ASC' }}
        bulkActionButtons ={false}
        title= "Deferral expire in a day"
        >
        <Datagrid  classes={{ headerCell: classes.header }} >
            <TextField source="ssn"     label="SSN"/>
            <TextField source="first_name"    label="First Name"/>
            <TextField source="last_name"    label="Last Name"/>
            <DateField source="dob"     label="DOB" locales="en-us"/>
            <TextField source="gender"  lable="Gender"/>
            <TextField source="don_ph"  lable="don_ph"/>
            <TextField source="deferral_code"    label="Deferral code"/>
            <DateField source="deferral_date"    label="Deferral date" locales="en-us"/>
            <DateField source="deferral_exp_date"    label="Deferral Exp" locales="en-us"/>
        </Datagrid>
    </List>
    </ErrorBoundary>  
);


export default withStyles(listStyles, styles)(ExpireList)